import React from "react";
import DashBoard from "./DashBoard";
import Header from "./Header";

const Home = () => {
    return (
        <>
            <Header />
            <DashBoard />
        </>
    );
};

export default Home;